module.exports = __webpack_public_path__ + "img/ifmKbm.53f2eff7.svg";